var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { appStrings } from '@backrs_ui/common-ui/src/assets/appStrings';
import { AppIcon } from '@backrs_ui/common-ui/src/designSystem/icons/AppIcon';
import { useContainerQuery } from '@backrs_ui/common-ui/src/hooks/useContainerQuery';
import { TRACK_CODE_TO_NAME } from '@backrs_ui/common-ui/src/models/careerPath';
import { Box, Button, Typography, Select, MenuItem, } from '@mui/material';
import ReactMarkdown from 'react-markdown';
import { UnlockItem, NAME_COLUMN_WIDTH, COLUMN_WIDTH, } from './AreYouOnTrackSummaryItem';
import { HorizontalCareerTrackBar } from './HorizontalCareerTrackBar';
var ARE_YOU_ON_TRACK_SUMMARY_STRINGS = appStrings.modules.assessMyTrack.areYouOnTrackSummary;
var SLUG_TO_SHORTNAME = {
    'academic-foundations': 'Academic',
    'real-world-experience': 'Achievement',
    'mindsets-and-skills': 'Skills',
    'community-of-success': 'Communitities',
    none: 'None',
};
export var AreYouOnTrackSummary = function (_a) {
    var careerTrack = _a.careerTrack, profileImageUrl = _a.profileImageUrl, buttonOnClick = _a.buttonOnClick, compact = _a.compact, academicFoundations = _a.academicFoundations, realWorldExperience = _a.realWorldExperience, mindsetsAndSkills = _a.mindsetsAndSkills, communityOfSuccess = _a.communityOfSuccess;
    var _b = useContainerQuery(900), containerRef = _b[0], isContainerCompact = _b[1];
    var isMobile = compact !== null && compact !== void 0 ? compact : isContainerCompact;
    var _c = useState(0), selectedCategoryIndex = _c[0], setSelectedCategoryIndex = _c[1];
    var careerTrackName = careerTrack ? TRACK_CODE_TO_NAME[careerTrack] : '';
    var isEmptyState = !careerTrack;
    var categories = isEmptyState
        ? [academicFoundations, realWorldExperience, mindsetsAndSkills, communityOfSuccess]
        : [academicFoundations, realWorldExperience, mindsetsAndSkills, communityOfSuccess].filter(function (category) { return category.strengths.length > 0; });
    var handleCategorySelect = function (event) {
        setSelectedCategoryIndex(event.target.value);
    };
    var renderCTAButton = function (isEmptyState) {
        if (isEmptyState) {
            return (_jsxs(Button, { id: "are-you-on-track-assess-btn", sx: buttonSx, hierarchy: "Primary", size: "md", onClick: buttonOnClick, children: [_jsx(AppIcon, { iconName: "Speedometer02", diameter: "20px", color: "Colors/Base/White" }), ARE_YOU_ON_TRACK_SUMMARY_STRINGS.assessYourTrack] }));
        }
        return (_jsxs(Button, { id: "are-you-on-track-check-progress-btn", sx: buttonSx, hierarchy: "Secondary gray", size: "md", onClick: buttonOnClick, children: [isMobile
                    ? ARE_YOU_ON_TRACK_SUMMARY_STRINGS.learnMoreMobile
                    : ARE_YOU_ON_TRACK_SUMMARY_STRINGS.learnMore, _jsx(AppIcon, { iconName: "ArrowCircleUpRight", diameter: "20px", color: "Colors/Foreground/fg-secondary" })] }));
    };
    return (_jsxs(Box, { ref: containerRef, sx: containerSx, children: [_jsxs(Box, { sx: titleAndDescriptionContainerSx(isMobile), children: [_jsxs(Box, { sx: titleAndDescriptionSx, children: [_jsx(Typography, { variant: "display-sm-semibold", children: ARE_YOU_ON_TRACK_SUMMARY_STRINGS.title }), _jsx(Typography, { variant: "text-sm-regular", color: function (_a) {
                                    var backrs = _a.backrs;
                                    return backrs.colors['Colors/Text/text-tertiary'];
                                }, children: _jsx(ReactMarkdown, { children: isEmptyState
                                        ? ARE_YOU_ON_TRACK_SUMMARY_STRINGS.descriptionEmptyState
                                        : ARE_YOU_ON_TRACK_SUMMARY_STRINGS.description(careerTrackName) }) })] }), !isMobile && renderCTAButton(isEmptyState)] }), careerTrack ? (_jsx(Box, { sx: barContainerSx, children: _jsx(HorizontalCareerTrackBar, { currentTrack: careerTrack, profileImageUrl: profileImageUrl }) })) : (_jsx(Box, { sx: emptyStateBarSx })), isMobile && categories.length > 1 && (_jsxs(Box, { sx: mobileCTAContainerSx, children: [renderCTAButton(isEmptyState), _jsx(Box, { sx: mobileDropdownContainerSx, children: _jsx(Select, { id: "are-you-on-track-category-select", value: selectedCategoryIndex, onChange: handleCategorySelect, sx: mobileDropdownSx, displayEmpty: true, children: categories.map(function (category, index) { return (_jsx(MenuItem, { value: index, children: _jsxs(Box, { sx: menuItemContentSx, children: [_jsx(Typography, { children: SLUG_TO_SHORTNAME[category.category.slug] }), _jsx(AppIcon, { iconName: "ChevronDown", diameter: "20px", color: "Colors/Foreground/fg-secondary" })] }) }, category.category.slug)); }) }) })] })), !isMobile && (_jsxs(Box, { sx: tableHeaderSx(isEmptyState), children: [_jsx(Box, { sx: headerImageColumnSx, children: _jsx(Typography, { variant: "text-xs-semibold", sx: headerTextSx, children: ARE_YOU_ON_TRACK_SUMMARY_STRINGS.theFourUnlocks }) }), _jsx(Box, { sx: headerCategoryColumnSx, children: _jsx(Typography, { variant: "text-xs-semibold", sx: headerTextSx, children: ARE_YOU_ON_TRACK_SUMMARY_STRINGS.fullName }) }), _jsx(Box, { sx: headerSectionColumnSx, children: _jsx(Typography, { variant: "text-xs-semibold", sx: headerTextSx, children: ARE_YOU_ON_TRACK_SUMMARY_STRINGS.yourStrengths }) }), _jsx(Box, { sx: headerSectionColumnSx, children: _jsx(Typography, { variant: "text-xs-semibold", sx: headerTextSx, children: ARE_YOU_ON_TRACK_SUMMARY_STRINGS.opportunitiesToGrow }) })] })), isMobile ? (categories[selectedCategoryIndex] && (_jsx(UnlockItem, __assign({}, categories[selectedCategoryIndex], { isMobile: true, isEmptyState: isEmptyState })))) : (_jsxs(_Fragment, { children: [(isEmptyState || academicFoundations.strengths.length > 0) && (_jsx(UnlockItem, __assign({}, academicFoundations, { isMobile: false, isEmptyState: isEmptyState }))), (isEmptyState || realWorldExperience.strengths.length > 0) && (_jsx(UnlockItem, __assign({}, realWorldExperience, { isMobile: false, isEmptyState: isEmptyState }))), (isEmptyState || mindsetsAndSkills.strengths.length > 0) && (_jsx(UnlockItem, __assign({}, mindsetsAndSkills, { isMobile: false, isEmptyState: isEmptyState }))), (isEmptyState || communityOfSuccess.strengths.length > 0) && (_jsx(UnlockItem, __assign({}, communityOfSuccess, { isMobile: false, isEmptyState: isEmptyState })))] }))] }));
};
var titleAndDescriptionContainerSx = function (isMobile) {
    return function (_a) {
        var backrs = _a.backrs;
        return ({
            display: 'flex',
            flexDirection: isMobile ? 'column-reverse' : 'row',
            justifyContent: 'space-between',
            alignItems: isMobile ? 'flex-start' : 'center',
            padding: backrs.spacing['spacing-2xl'],
            gap: isMobile ? 0 : backrs.spacing['spacing-2xl'],
        });
    };
};
var titleAndDescriptionSx = {
    display: 'flex',
    flexDirection: 'column',
};
var buttonSx = {
    whiteSpace: 'nowrap',
    flexShrink: 0,
};
var containerSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: backrs.radius['radius-xl'],
        border: "1px solid ".concat(backrs.colors['Colors/Foreground/fg-secondary']),
        backgroundColor: backrs.colors['Colors/Base/White'],
        overflow: 'hidden',
    });
};
var tableHeaderSx = function (isEmptyState) {
    return function (_a) {
        var backrs = _a.backrs;
        return ({
            display: 'flex',
            flexDirection: 'row',
            width: '100%',
            gap: backrs.spacing['spacing-2xl'],
            px: backrs.spacing['spacing-2xl'],
            py: backrs.spacing['spacing-lg'],
            borderTop: isEmptyState
                ? "1px solid ".concat(backrs.colors['Colors/Foreground/fg-quinary'])
                : "1px solid ".concat(backrs.colors['Colors/Foreground/fg-secondary']),
        });
    };
};
var headerImageColumnSx = {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    minWidth: COLUMN_WIDTH,
    maxWidth: COLUMN_WIDTH,
};
var headerCategoryColumnSx = {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    minWidth: NAME_COLUMN_WIDTH,
    maxWidth: NAME_COLUMN_WIDTH,
};
var headerSectionColumnSx = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
};
var headerTextSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        color: backrs.colors['Colors/Text/text-quaternary'],
    });
};
var barContainerSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        width: '95%',
        marginBottom: backrs.spacing['spacing-4xl'],
    });
};
var mobileDropdownContainerSx = {
    width: '100%',
};
var mobileDropdownSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        width: '100%',
        '& .MuiSelect-select': {
            padding: "".concat(backrs.spacing['spacing-xl'], " ").concat(backrs.spacing['spacing-lg']),
        },
        '& .MuiMenuItem-root': {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
        },
    });
};
var emptyStateBarSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        width: '95%',
        marginBottom: backrs.spacing['spacing-2xl'],
        backgroundColor: backrs.colors['Colors/Background/bg-quaternary'],
        height: '8px',
        borderRadius: backrs.radius['radius-full'],
    });
};
var mobileCTAContainerSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        gap: backrs.spacing['spacing-md'],
        padding: backrs.spacing['spacing-md'],
    });
};
var menuItemContentSx = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    paddingRight: '8px',
};
